export default "__VITE_ASSET__DhtPbzkt__"